module.exports = (__webpack_require__(9))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./assets/js/fields/components/field/index.js from dll-reference carbon.core
// module id = 56
// module chunks = 0